export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';
export const SET_ORGANIZATION = 'SET_ORGANIZATION';
export const ADD_ORGANIZATION = 'ADD_ORGANIZATION';
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
export const REMOVE_ORGANIZATION = 'REMOVE_ORGANIZATION';
export const CLEAR_ORGANIZATION = 'CLEAR_ORGANIZATION';
export const CLEAR_ORGANIZATIONS = 'CLEAR_ORGANIZATIONS';
